/* Optional entrance motion. Never hide content while waiting for JavaScript. */
(() => {
  if (window.sweHomeGuidesInitialized) return;
  window.sweHomeGuidesInitialized = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root) => {
    if (!('IntersectionObserver' in window) || reducedMotion.matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        if (reducedMotion.matches || !target.animate) return;
        target.animate([
          { opacity: 0.7, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 450, easing: 'cubic-bezier(.2,.7,.3,1)' });
      });
    }, { threshold: 0.12 });
    root.querySelectorAll('.swe-home-guides [data-guide-reveal]').forEach((el) => observer.observe(el));
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
